import CryptoJS from 'crypto-js';

export const useSetMap: { [key: string]: string } = {
    클래스: 'set1',
    URL: 'set3',
    출력용: 'set2',
};

export const detailUseSetMap: { [key: string]: string } = {
    '비바클래스 발행': 'set1',
    'URL 응시 발행': 'set3',
    '시험지 출력': 'set2',
};

export const stateSetMap: { [key: string]: string } = {
    진행중: 'set1',
    예정: 'set2',
    종료: 'set3',
};

export const gradingSetMap: { [key: string]: string } = {
    '채점 완료': 'set1',
    '채점 필요': 'set2',
    직접채점: 'set3',
};

export const difficultyMap: { [key: string]: string } = {
    산: 'top',
    상: 'top',
    중상: 'middle',
    중: 'middle',
    중하: 'middle',
    하: 'bottom',
};

export const schoolMap: { [key: string]: string } = {
    ES: '초등학교',
    MS: '중학교',
    HS: '고등학교',
};

export const timeAddArr = [
    {
        value: 60,
        label: '1시간',
    },
    {
        value: 30,
        label: '30분',
    },
    {
        value: 10,
        label: '10분',
    },
    {
        value: 5,
        label: '5분',
    },
];

export const publishTypeArr = [
    {
        value: 0,
        label: '전체 선택',
    },
    {
        value: 1,
        label: '비바클래스 발행',
    },
    {
        value: 2,
        label: 'URL 응시 발행',
    },
    {
        value: 3,
        label: '시험지 출력',
    },
];

export const publishStateArr = [
    {
        value: 0,
        label: '전체 선택',
    },
    {
        value: 1,
        label: '예정',
    },
    {
        value: 2,
        label: '진행중',
    },
    {
        value: 3,
        label: '종료',
    },
];

const EXCLUDED_CLASS_STUDENT_STATES = new Set(['2', '3', '4', '6', '7']);

export const isVisibleClassStudent = (
    member: Pick<API.MyClassMemberList.MemberInfo, 'studentState'> | null | undefined
) => !!member && !EXCLUDED_CLASS_STUDENT_STATES.has(member.studentState);

export const nickPublishStateArr = [
    {
        value: 0,
        label: '전체 선택',
    },
    {
        value: 2,
        label: '진행중',
    },
    {
        value: 3,
        label: '종료',
    },
];

export const handleMaskMiddle = (str: string) => {
    if (str.length <= 2) return str;

    const first = str[0];
    const last = str[str.length - 1];
    const masked = '*'.repeat(str.length - 2);

    return first + masked + last;
};

export const findColor = (type: string) => {
    switch (type) {
        case 'URL':
            return 'orange';
        case '클래스':
            return 'blue';
        case '출력용':
            return 'pink';
        default:
            return 'blue';
    }
};

export const encryptDataDeterministic = (data: object) => {
    const jsonString = JSON.stringify(data);

    // Key, IV 를 WordArray 로 변환
    const key = CryptoJS.enc.Utf8.parse(import.meta.env.VITE_SECRET_KEY_32);
    const iv = CryptoJS.enc.Utf8.parse(import.meta.env.VITE_IV_16);

    // 직접 key/iv 를 넘겨주면 salt 없이 순수 CBC 암호화
    const encrypted = CryptoJS.AES.encrypt(jsonString, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    // encrypted.ciphertext 는 WordArray(바이너리) → Base64 로 변환
    const rawB64 = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    // URL-safe Base64 로 변환 (+= 패딩은 제거)
    const urlSafe = rawB64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return urlSafe;
};

export const decryptDataDeterministic = (encryptedBase64: string): any => {
    // 1) Key, IV 준비
    const key = CryptoJS.enc.Utf8.parse(import.meta.env.VITE_SECRET_KEY_32);
    const iv = CryptoJS.enc.Utf8.parse(import.meta.env.VITE_IV_16);

    let b64 = encryptedBase64.replace(/-/g, '+').replace(/_/g, '/');
    // 4의 배수가 되도록 패딩 추가
    b64 += '='.repeat((4 - (b64.length % 4)) % 4);
    // 4의 배수가 되도록 = 추가
    const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Base64.parse(b64),
    });
    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    // 4) UTF8 문자열로 변환 후 JSON 파싱
    const jsonString = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(jsonString);
};

export const MAX_CLASS_MIN = 120; // 클래스 발행 타이머 최대 시간
export const MAX_CLASS_PERIOD_MIN = 1439; // 클래스 발행 응시기간 ON 타이머 최대 시간

export const handleInputDateChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: 'hours' | 'minutes',
    publishType: number,
    pdSetAt: string,
    hours: number,
    minutes: number,
    setHours: React.Dispatch<React.SetStateAction<number>>,
    setMinutes: React.Dispatch<React.SetStateAction<number>>
) => {
    const value = e.target.value;

    // 숫자만 허용
    if (!/^\d*$/.test(value)) return;

    if (type === 'hours') {
        // 빈 문자열이면 0 처리
        let h = value === '' ? 0 : Number(value);
        if (publishType === 1 && pdSetAt === 'N') h = Math.min(h, 2);
        if ((publishType === 1 && pdSetAt === 'Y') || publishType === 2) h = Math.min(h, 23);

        let total = h * 60 + minutes;
        if (publishType === 1 && pdSetAt === 'N') total = Math.min(total, MAX_CLASS_MIN);
        if ((publishType === 1 && pdSetAt === 'Y') || publishType === 2)
            total = Math.min(total, MAX_CLASS_PERIOD_MIN);

        setHours(Math.floor(total / 60));
        setMinutes(total % 60);
    } else if (type === 'minutes') {
        // 분은 0~59만 허용
        if (value !== '' && Number(value) > 59) return;
        const m = value === '' ? 0 : Number(value);

        let total = hours * 60 + m;
        if (publishType === 1 && pdSetAt === 'N') total = Math.min(total, MAX_CLASS_MIN);
        if ((publishType === 1 && pdSetAt === 'Y') || publishType === 2)
            total = Math.min(total, MAX_CLASS_PERIOD_MIN);

        setHours(Math.floor(total / 60));
        setMinutes(total % 60);
    }
};

// 분 더하기 버튼 처리
export const addMinutes = (
    addMinutes: number,
    publishType: number,
    pdSetAt: string,
    hours: number,
    minutes: number,
    setHours: React.Dispatch<React.SetStateAction<number>>,
    setMinutes: React.Dispatch<React.SetStateAction<number>>
) => {
    let total = hours * 60 + minutes + addMinutes;
    if (publishType === 1 && pdSetAt === 'N') total = Math.min(total, MAX_CLASS_MIN);
    if ((publishType === 1 && pdSetAt === 'Y') || publishType === 2)
        total = Math.min(total, MAX_CLASS_PERIOD_MIN);
    if (total < 0) total = 0; // 음수 방지(옵션)

    const newHours = Math.floor(total / 60);
    const newMinutes = total % 60;

    setHours(newHours);
    setMinutes(newMinutes);
};

// 발행 상세 학생 번호순, 이름순 정렬
const koCollator = new Intl.Collator('ko', {
    usage: 'sort',
    sensitivity: 'base',
    numeric: true,
    ignorePunctuation: true,
});

// 1) flnm 가나다 정렬
export const byNameKo = (list: DATA.StntInfoType[]) =>
    [...list].sort((a, b) => {
        const an = (a.flnm ?? '').trim();
        const bn = (b.flnm ?? '').trim();
        const nameCmp = koCollator.compare(an, bn);
        if (nameCmp !== 0) return nameCmp;

        // 동명이인일 땐 num으로 안정화
        const anNum = a.num ?? Number.POSITIVE_INFINITY;
        const bnNum = b.num ?? Number.POSITIVE_INFINITY;
        return anNum - bnNum;
    });

// 2) num 숫자 오름차순 정렬
export const byNumAsc = (list: DATA.StntInfoType[] | DATA.PublishStntListType[]) =>
    [...list].sort((a, b) => {
        const an = a.num ?? Number.POSITIVE_INFINITY;
        const bn = b.num ?? Number.POSITIVE_INFINITY;
        if (an !== bn) return an - bn;

        // 같은 번호면 이름 가나다
        const anm = (a.flnm ?? '').trim();
        const bnm = (b.flnm ?? '').trim();
        return koCollator.compare(anm, bnm);
    });

/** 교과서 접미사가 붙은 발행 ID에서도 클래스 식별자 5개 구간을 정확히 비교합니다. */
export const isSamePublishClass = (claId: string, selectedClaId: string) => {
    const classParts = claId.split('-');
    const selectedParts = selectedClaId.split('-');
    return (
        classParts.length >= 5 &&
        selectedParts.length >= 5 &&
        classParts.slice(0, 5).every((part, index) => part === selectedParts[index])
    );
};
